import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import AddUserSvg from '../assets/svgs/addUser';

import PermissionForm from '../sections/users/permissionForm';
import pageTitle from "../utils/pageTitles.json";
import { PermissionContext } from '../context/PermissionContext';
import DetailsForm from '../sections/users/detailsForm';
import { axiosGetCall, axiosPostCall } from '../services/apisCall';

import { renderErrorMessage, renderSuccessMessage } from '../lib/toastMessage';
import { ToastContainer } from 'react-toastify';

const logger = new Logger("kycListTable");
import Logger from '../lib/Logger';

//@mui
import { styled } from '@mui/material/styles';
import { Alert, Box, Button, Stack, TextField, Typography } from '@mui/material';
import SelectPage from 'src/sections/panelPermission/detailsForm';
import PagePermissions from 'src/sections/panelPermission/permission';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useBoolean } from 'src/hooks/use-boolean';

const MainSection = styled('div')(() => ({
  width: '100%',
  padding: '64px 20px 0px 88px',
  backgroundColor: "rgb(240, 240, 240)"/* theme.palette.background.default */,
  height: '100vh'
}));

const MainSectionInner = styled('div')(() => ({
  backgroundColor: "#fff",
  padding: '30px 20px',
  borderRadius: '6px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  height: `calc(${window.innerHeight}px - 157px)`
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
  width: '100%',
  padding: "20px 0px 20px 0px",
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row'
}));

const PageInput = ({ pageDialog, addNewPage }) => {
  const [newPageName, setNewPageName] = useState("");

  const handleConfirm = () => {
    addNewPage(newPageName)
    pageDialog.onFalse()

  }
  const NewPageInputContent = (

    <TextField
      id="outlined-basic"
      label="Enter Page Name"
      variant="outlined"
      value={newPageName} 
      onChange={(e) => setNewPageName(e.target.value)}
      fullWidth
    />
  )

  const newPageDialogAction = () => {
    return (
      <Button onClick={handleConfirm}>
        Confirm
      </Button>
    )
  }
  return (

    <ConfirmDialog title="Enter new page" content={NewPageInputContent} open={pageDialog.value} onClose={() => pageDialog.onFalse()} action={newPageDialogAction()} />
  )
}

const UpdatePanelPermission = () => {

  const pageDialog = useBoolean();
  const [tabPanel, setTabPanel] = useState({})
  const [tabs, setTabs] = useState({})
  const [selectedPanel, setSelectedPanel] = useState(null);
  // Snapshot of saved permissions: key -> parent panel id, used to point duplicate-key errors at the section where the key already exists
  const [savedKeyToParent, setSavedKeyToParent] = useState({});

  const handleTabDelete = (tab) => {
    const { id, parent } = tab;
    const newTabPanel = JSON.parse(JSON.stringify(tabPanel?.[parent]))
    const index = newTabPanel.child.indexOf(id);
    if (index > -1) {
      newTabPanel.child.splice(index, 1);
    }

    setTabs((prev) => {
      const updatedTabs = { ...prev };
      delete updatedTabs?.[id];
      return updatedTabs;
    })

    setTabPanel((tabPanel) => {
      const obj = { ...tabPanel }
      obj[parent] = newTabPanel
      return obj;
    })
  }

  const handleTabAdd = (parentObj) => {
    const { id, child } = parentObj;

    const newTabPanel = JSON.parse(JSON.stringify(parentObj))

    if (child.length > 0) {
      const childId = parseInt(child[child.length - 1]) + 1;
      const newTab = {
        parent: id,
        r: [],
        w: [],
        id: childId,
        title: '',
        type: 'child',
      }

      setTabs((tabs) => {
        const obj = { ...tabs };
        obj[childId] = newTab
        return obj;
      })

      newTabPanel.child.push(childId);
      setTabPanel((tabPanel) => {
        const obj = { ...tabPanel }
        obj[id] = newTabPanel
        return obj;
      })


    }
    else {
      const childId = parseInt(id) * 1000 + 1;
      const newTab = {
        parent: id,
        r: [],
        w: [],
        id: childId,
        title: '',
        type: 'child',
      }
      setTabs((tabs) => {
        const obj = { ...tabs };
        obj[childId] = newTab
        return obj;
      })

      newTabPanel.child.push(childId);
      setTabPanel((tabPanel) => {
        const obj = { ...tabPanel }
        obj[id] = newTabPanel
        return obj;
      })

    }

  }

  const updateTabRoute = (id, type, value) => {
    setTabs((prev) => {
      const updatedTab = { ...prev };
      updatedTab[id][type] = value;
      return updatedTab;
    })

  }

  const deletePage = (id) => {
    setTabPanel((prev) => {
      const newTabPanel = { ...prev };
      const children = newTabPanel[id].child;

      if (children.length > 0) {

        setTabs((prev) => {
          const newTabs = { ...prev };
          for (let i = 0; i < children.length; i++) {
            const element = children[i];
            delete newTabs?.[element];
          }
          return newTabs;
        })

      }
      delete newTabPanel?.[id];
      return newTabPanel;
    })
    setSelectedPanel(null);
  }

  const handleAddPage = () => {

    pageDialog.onTrue();

  }


  const addNewPage = (newPageName) => {
    const array = Object.keys(tabPanel).map((id) => parseInt(id));
    const latestId = Math.max(...array)
    setTabPanel((tabPanel) => {
      const newTabPanel = { ...tabPanel };
      const newPage = {
        id: latestId + 1,
        title: newPageName,
        type: 'parent',
        child: [],

      }
      newTabPanel[latestId + 1] = newPage;
      return newTabPanel;
    })
  }

  const updatePageTitle = (tabPanelId, value) => {
    const { id } = tabPanelId;

    setTabPanel((tabPanel) => {
      const newTabPanel = { ...tabPanel };
      newTabPanel[id].title = value;
      return newTabPanel;
    })

  }

  const updateTabName = (tab, value) => {
    const { id } = tab;
    setTabs((prev) => {
      const newTab = { ...prev };
      newTab[id].title = value;
      return newTab;
    });
  };

  const updateTabKey = (tab, value) => {
    const { id } = tab;
    setTabs((prev) => {
      const newTab = { ...prev };
      newTab[id].key = value;
      return newTab;
    });
  };

  const validateTabs = (tabsArray) => {
    const camelCaseRegex = /^[a-z][a-zA-Z0-9]*$/;
    const seenKeys = new Set();

    for (const tab of tabsArray) {
      if (!tab.key) return `Permission "${tab.title}" is missing a key.`;
      if (!camelCaseRegex.test(tab.key)) return `Key "${tab.key}" is invalid — use camelCase only (e.g. shiftAm).`;
      if (seenKeys.has(tab.key)) {
        // Point at the section where the key already exists (saved), falling back to the current tab's section for brand-new keys
        const parentId = savedKeyToParent[tab.key] ?? tab.parent;
        const section = tabPanel?.[parentId]?.title || 'another section';
        return `Duplicate key "${tab.key}" already used in section "${section}". Each permission must have a unique key.`;
      }
      seenKeys.add(tab.key);
    }
    return null;
  };

  const updatePermission = async () => {
    const tabsArray = Object.values(tabs);
    const validationError = validateTabs(tabsArray);
    if (validationError) return renderErrorMessage(validationError);

    try {
      const { message } = await axiosPostCall("updatePanelPermission", { tabs: tabsArray, tabPanel: Object.values(tabPanel) });
      return renderSuccessMessage(message);
    } catch (error) {
      renderErrorMessage(error?.message);
      console.error(error);
    }
  }

  const STRIP_WORDS = new Set(['can', 'is', 'are', 'has', 'have', 'the', 'a', 'an', 'and', 'or', 'of', 'to', 'in', 'for', 'with', 'by']);

  // Generates camelCase key, stripping filler words
  // e.g. "Can Update Console Admin" → "updateConsoleAdmin", "Shift AM" → "shiftAm"
  const titleToCamelCase = (title = '') => {
    const meaningful = title
      .trim()
      .split(/\s+/)
      .filter((w) => w && !STRIP_WORDS.has(w.toLowerCase()));
    if (!meaningful.length) return '';
    return meaningful
      .map((word, i) => {
        const clean = word.replace(/[^a-zA-Z0-9]/g, '');
        if (!clean) return '';
        return i === 0
          ? clean.charAt(0).toLowerCase() + clean.slice(1).toLowerCase()
          : clean.charAt(0).toUpperCase() + clean.slice(1).toLowerCase();
      })
      .join('');
  };

  const getPanelPermission = async () => {
    try {
      const { tabs, tabPanel } = await axiosGetCall("getPanelPermission");
      // Pre-fill key from title for existing permissions that have no key set
      const tabsWithKeys = Object.fromEntries(
        Object.entries(tabs).map(([id, tab]) => [
          id,
          { ...tab, key: tab.key || titleToCamelCase(tab.title) },
        ])
      );
      // Build key -> parent lookup from the saved permissions for duplicate-key error reporting
      const keyToParent = Object.fromEntries(
        Object.values(tabsWithKeys).map((tab) => [tab.key, tab.parent])
      );
      setSavedKeyToParent(keyToParent);
      setTabs(tabsWithKeys);
      setTabPanel(tabPanel);
    } catch (error) {
      renderErrorMessage(error?.message)
      console.error(error)
    }
  }

  useEffect(() => {
    getPanelPermission()
  }, [])

  return (
    <>
      <Helmet>
        <title> {`${pageTitle?.addNewUser}`} </title>
      </Helmet>
      {/* <ToastContainer /> */}
      <MainSection>

        <HeadingSection>
          <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '10px',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <Box sx={{
              widht: '16px',
              height: '16px',
              mt: -1.8
            }}>
              <AddUserSvg />
            </Box>
            <Typography variant='h5' sx={{ color: 'grey.10', fontWeight: 600 }}>
              Update Panel Permissions
            </Typography>
          </Box>
        </HeadingSection>

        <MainSectionInner>
          <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert severity="warning">Developer Notice: This page is restricted to developers only. Please do not make any unauthorized changes to the permission flow.</Alert>
          </Stack>
          <SelectPage tabPanel={tabPanel} selectedPanel={selectedPanel} setSelectedPanel={setSelectedPanel} handleAddPage={handleAddPage} />

          {selectedPanel && <PagePermissions tabsIds={tabPanel?.[selectedPanel] || {}} tabs={tabs} handleTabDelete={handleTabDelete} handleTabAdd={handleTabAdd} updateTabName={updateTabName} updateTabKey={updateTabKey} updatePageTitle={updatePageTitle} updateTabRoute={updateTabRoute} deletePage={deletePage} />}
          <PageInput pageDialog={pageDialog} addNewPage={addNewPage} />
          <Button
            variant='contained'
            color='success'
            sx={{ width: "30px" }}
            onClick={updatePermission}
            disabled={!selectedPanel}
          >Update</Button>
        </MainSectionInner>
      </MainSection >
    </>
  )
}

export default UpdatePanelPermission;